module.exports = __webpack_public_path__ + "img/1.42311a1f.jpg";